import { render, staticRenderFns } from "./SlideFade.vue?vue&type=template&id=5ff173ba&scoped=true&lang=pug&"
var script = {}
import style0 from "./SlideFade.vue?vue&type=style&index=0&id=5ff173ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff173ba",
  null
  
)

export default component.exports